import ko from "knockout";

/**
 * <p>Binding handler for rendering localized date strings. Parameters are:</p>
 * <dl>
 *  <dt>date</dt>
 *  <dd>the date to format in the current locale</dd>
 *  <dt>format</dt>
 *  <dd>the globalize format to use. Default is 'f'. More explaination here: https://github.com/jquery/globalize#date-formatting</dd>
 *  <dt>locale</dt>
 *  <dd>the locale to use. Default is current locale</dd>
 *</dl>
 * <pre class="prettyprint">
 * &lt;span data-bind="lDuration: {date: new Date(), format: "F"}"&gt;
 * &lt;/span&gt;
 * </pre>
 *
 * @exports extensions/i18n/knockout-lDuration
 */
ko.bindingHandlers.lDuration = {
    init: function () {},
    update: function (element, valueAccessor) {
        const durationVal = ko.utils.unwrapObservable(valueAccessor());
        element.innerHTML = ko.i18n.formatDuration(durationVal) || "";
    },
};

export default ko.bindingHandlers.lDuration;
